import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import { MatchMiaiKind } from "../../../define/MatchMiaiKind";
import MatchMiaiLevelBase from "./MatchMiaiLevelBase";

const {ccclass, property} = cc._decorator;

/** 待机说话 */
const c_standbyTalk = [
    
];

/** 点击说话 */
const c_hitTalk = [
    ['打不到，打不到', 'match_hit_1']
    , ['这动作简直,泰裤辣~', 'match_hit_2']
    , ['那欺负爹爹的武器是没用的', 'match_hit_3']
    , ['你又不是丘比特来射我的爱', 'match_hit_4']
    , ['行不行呀，我都要犯困了', 'match_hit_5']
    , ['呀呀呀~真菜', 'match_hit_5']
];

/** 丘比特之箭射击说话 */
const c_cupidTalk = [
    "别这样，讨厌！！！",
    "就只知道欺负人家~",
    "越来越中意你了",
    "讨厌，你好坏啊",
    "受不了啦，我投降",
];

/** 丘比特之箭每次说话需要射中次数 */
const c_cupidEveryTalk = 6;
/** 丘比特之箭射中多少次胜利 */
const c_cupidWinCount = 25;

const c_hit_count = 10;
const c_standby_time = 6;

const c_start_gold = 1000000;
/** 重置点击次数时间 */
const c_reset_touch_time = 0.5;

const c_end_award_goods = 50010;
@ccclass
export default class MatchMiaiLevel2 extends MatchMiaiLevelBase {


	@property({ type: cc.Sprite, displayName:'' })
	sprRoleCollapse: cc.Sprite = null;

	@property({ type: cc.Label, displayName:'' })
	labelTalk: cc.Label = null;

	@property({ type: cc.Node, displayName:'' })
	nodeTalk: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	nodeGame: cc.Node = null;

    @property(cc.Node)
    nodeLeftLeg: cc.Node = null;
    @property(cc.Node)
    nodeRightLeg: cc.Node = null;
    @property(cc.Node)
    nodeBottomLeg: cc.Node = null;
    @property(cc.Node)
    nodeLeftHand: cc.Node = null;
    @property(cc.Node)
    nodeRightHand: cc.Node = null;
    @property(cc.Node)
    nodeBody: cc.Node = null;
    @property(cc.Node)
    nodeTopLeft: cc.Node = null;
    @property(cc.Node)
    nodeTopRight: cc.Node = null;

    private hitCount = 0;
    private standbyTime = 0;

    private bShowTalk = false;

    /** 连续点击次数 */
    private conTouchCount = 0;

    initLayer() {
        super.initLayer();

        this.nodeTalk.active = false;
	    this.sprRoleCollapse.node.active = false;

        this.onClickStartGame();
        
        // this.showEquipList();
    }

    resetData() {
        super.resetData();

        this.conTouchCount = 0;
        this.bShowTalk = false;
        this.nodeTalk.active = false;
        this.hitCount = 0;
        this.standbyTime = 0;
    }

    setGameState(enable: boolean) {
        this.nodeGame.active = enable;
        this.showCloseBtn(enable);
    }

    checkIsInRole(worldPos:cc.Vec2){

        if (!this.bStartHit) {
            return;
        }

        let bAdjustHit = true;
        let special_type = this.csvEquip.special_type;
        if (utilsModel.isValidNumberValue(special_type)) {
            switch(special_type) {
                case MatchMiaiKind.SpecialEquipType.CUPID_ARROW: {
                    bAdjustHit = false;
                }
                break;
            }
        }

        if (bAdjustHit) {
            let triggerNode:cc.Node = null;

            for(let i = 0;i<this.roleTriggerNode.childrenCount;i++){
                let node:cc.Node = this.roleTriggerNode.children[i];
                if (!node.active) {
                    continue;
                }
                let box:cc.PolygonCollider = node.getComponent(cc.PolygonCollider);
                let touchPos = node.convertToNodeSpaceAR(worldPos);
                let points = box.points;
                touchPos.x -= box.offset.x;
                touchPos.y -= box.offset.y;
                let isTrigger:boolean = cc.Intersection.pointInPolygon(touchPos, points);
                if(isTrigger){
                    triggerNode = node;
                    break;
                }
            }
    
            this.hitTalk();
            if(!triggerNode){
                // 未击中，播放嘲讽话语
                
                return;            
            }
    
            //TODO 角色做出相对应的反应
            // cc.log('击中',triggerNode.name);
    
            // let siblingIndex = triggerNode.getSiblingIndex();
            let movex = 0;
            let movey = 0;
            const vY = 15 + 10;
            const hX = 15 + 10;
            this.showAni(triggerNode);
            switch(triggerNode) {
                case this.nodeLeftLeg: {
                    // 左脚
                }
                break;
                case this.nodeRightLeg: {
                    // 右脚
                }
                break;
                case this.nodeBottomLeg: {
                    // 底部
                    movey = vY;
                }
                break;
                case this.nodeLeftHand: {
                    // 左手
                    movex = hX;
                }
                break;
                case this.nodeRightHand: {
                    // 右手
                    movex = -hX;
                }
                break;
                case this.nodeBody: {
                    // 身体
                    movey = -vY;
                }
                break;
                case this.nodeTopLeft: {
                    // 左上部
                }
                break;
                case this.nodeTopRight: {
                    // 右上部
                }
                break;
            }
            if (movex != 0 || movey != 0) {
                let endPos = cc.v2(this.nodeRole.x + movex, this.nodeRole.y + movey);
                if (this.moveArea.getBoundingBox().contains(endPos)) {
                    this.nodeRole.setPosition(endPos);
                } else {
                    console.log('超出区域');
                }
            }

            this.curEquipHitCount += this.hitBulletCount;
        } else {
            this.curEquipHitCount += this.hitBulletCount;

            this.playRoleAni(6, 0.2);
            if ((this.curEquipHitCount-1) % c_cupidEveryTalk == 0) {
                let tIdx = Math.floor((this.curEquipHitCount-1) / c_cupidEveryTalk);
                this.showTalk([c_cupidTalk[tIdx]]);
            }
            if (this.curEquipHitCount >= c_cupidWinCount) {
                // let matchMiaiDataManage = UserDataManage.instance.matchMiaiDataManage;
                // let matchMiaiData = matchMiaiDataManage.matchMiaiData;
                // matchMiaiData.bEndSecond = true;
                // matchMiaiData.saveLocalData();
                this.bStartHit = false;

                this.gameEndShow();
            }
        }
    }

    hitTalk() {
        if (this.bShowTalk) {
            return;
        }

        this.hitCount++;
        if (this.hitCount < c_hit_count) {
            return;
        }
        this.hitCount = 0;

        let len = c_hitTalk.length;
        let idx = data_control.randomNumInt(0, len-1);
        let strTalk = c_hitTalk[idx];
        this.showTalk(strTalk);
    }

    standbyTalk() {
        let len = c_standbyTalk.length;
        if (len <= 0) {
            return;
        }
        let idx = data_control.randomNumInt(0, len-1);
        let strTalk = c_standbyTalk[idx];
        this.showTalk(strTalk);
    }

    async showTalk(str: string[]) {
        this.nodeTalk.active = true;
        this.labelTalk.string = str[0];
        this.nodeTalk.stopAllActions();
        this.bShowTalk = true;

        // let time = await this.playSound(str[1]);
        let time = 2;
        this.nodeTalk.opacity = 0;
        cc.tween(this.nodeTalk)
            .to(0.3, {opacity: 255})
            .delay(time)
            .to(0.3, {opacity: 0})
            .call(()=> {
                this.bShowTalk = false;
                this.nodeTalk.active = false;
            })
            .start();
    }

    showAni(hitNode: cc.Node) {
        let aniNode = [
            this.nodeBody
            , this.nodeLeftLeg
            , this.nodeRightLeg
            , this.nodeBottomLeg
            , this.nodeRightHand
            , this.nodeLeftHand
        ];
        let idx = aniNode.indexOf(hitNode);
        this.playRoleAni(idx);
    }

    playRoleAni(idx: number, addTime: number = 0) {
        this.sprRole.setFill(0);
        if (idx != -1) {
            this.sprRole.node.stopAllActions();

            cc.tween(this.sprRole.node)
            .delay(0.01)
            .call(()=> {
                this.sprRole.setFill(idx+1);
            })
            .delay(0.2 + addTime)
            .call(()=> {
                this.sprRole.setFill(0);
            })
            .start();
        }
    }

    async gameEndShow() {

        O1HD.getManagers().soundMgr.stopAllEffects();
        O1HD.getManagers().soundMgr.playSound("match_miai_win").then();

        // this.nodeTalk.stopAllActions();
        // this.nodeTalk.active = false;
        // this.bShowTalk = false;
        this.showCloseBtn(false);

        this.nodeRoleJump.active = false;
	    this.sprRoleCollapse.node.active = true;

        this.scheduleOnce(async ()=> {
            await this.showEndAward();
            this.openFinishEvent();
        }, 2);
    }

    openFinishEvent() {
        this._carryData.parent.openEndSecondLevelEvent();
    }

    async showEndAward() {

        // this.onPushGoods(c_end_award_goods, 1);

        let addGoodsList = {};
        addGoodsList[c_end_award_goods] = 1;
        await this.openGetGoodsLayer(0, 0, addGoodsList);
    }

    onClickStartGame() {
        this.stopSound();
        this.bStartHit = true;
        this.setGameState(true);
        this.showEuqipUI();
    }

    onClickOpenEquip() {
        if (!this.bStartHit) {
            return;
        }

        this.unschedule(this.resetTouchCount);

        this.conTouchCount++;
        if (this.conTouchCount >= 3) {
            this.resetTouchCount();
            this.showEquipList(true);
        } else {
            this.scheduleOnce(this.resetTouchCount, c_reset_touch_time);
        }
    }

    resetTouchCount() {
        this.conTouchCount = 0;
    }

    protected update(dt: number): void {
        if (!this.bStartHit) {
            return;
        }
        if (this.bShowTalk) {
            return;
        }
        this.standbyTime += dt;
        if (this.standbyTime < c_standby_time) {
            return;
        }
        this.standbyTime = 0;
        this.standbyTalk();
    }
}
